import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import HeadingModule from '../components/Layout/HeadingComponent/Heading';
import Form from 'react-bootstrap/Form';
import { Link } from 'react-router-dom';

const SettingModule = ({themHandler}) => {

    const [color, setColor] = useState(true);
    
    useEffect(() => {
        if(typeof window !== 'undefined') {
            setColor(localStorage.getItem("themColor") === "zl_light_theme_active" ? false : localStorage.getItem("themColor") !== null && true);
        }
    }, []);

    return (
        <>
            <section className="zl_settings_page">
                <HeadingModule name={'Ajustes'} />
                <div className="zl_setting_list">
                    <div className="zl_setting_list_items">
                        <div className="zl_setting_items_heading_peregraph">
                            <h3>Notificaciones</h3>
                            <p>Mostrar una notificación cuando se reciban fondos</p>
                        </div>
                        <Form.Check
                            type="switch"
                            id='checkbox1'
                            label=""
                            className="zl_custom_currency_checkbox"
                            defaultChecked
                        />
                    </div>
                    <Link to={'/currency'} className="zl_setting_list_items">
                        <div className="zl_setting_items_heading_peregraph">
                            <h3>Activos</h3>
                            <p>Elige tu activo local.</p>
                        </div>
                        <div className="zl_setting_items_right_text">
                            <h3>AUD</h3>
                            <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1L6.08833 6L1 11" stroke="#828CAE" strokeWidth="2.4" />
                            </svg>
                        </div>
                    </Link>
                    <Link to={'/restorewallet'} className="zl_setting_list_items">
                        <div className="zl_setting_items_heading_peregraph">
                            <h3>Restaurar wallet</h3>
                            <p>Sobreescribe tu cartera actual usando 12 palabras a modo de frase de recuperación.</p>
                        </div>
                        <div className="zl_setting_items_right_text">
                            <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1L6.08833 6L1 11" stroke="#828CAE" strokeWidth="2.4" />
                            </svg>
                        </div>
                    </Link>
                    <div className="zl_setting_list_items">
                        <div className="zl_setting_items_heading_peregraph">
                            <h3>Cambiar tema</h3>
                            <p>Activa/desactiva el modo noche.</p>
                        </div>
                        <Form.Check
                            type="switch"
                            id='checkbox2'
                            label=""
                            className="zl_custom_currency_checkbox"
                            checked={color}
                            onChange={() => {
                                setColor(!color);
                                themHandler(color);
                            }}
                        />
                    </div>
                </div>
            </section>
        </>
    );
}

export default connect(null, null)(SettingModule);
